import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonEN from '../locales/en/common.json';
import authEN from '../locales/en/auth.json';
import tradingEN from '../locales/en/trading.json';
import toolsEN from '../locales/en/tools.json';
import pagesEN from '../locales/en/pages.json';
import dashboardEN from '../locales/en/dashboard.json';
import accountsEN from '../locales/en/accounts.json';
import insightsEN from '../locales/en/insights.json';

import commonTR from '../locales/tr/common.json';
import authTR from '../locales/tr/auth.json';
import tradingTR from '../locales/tr/trading.json';
import toolsTR from '../locales/tr/tools.json';
import pagesTR from '../locales/tr/pages.json';
import dashboardTR from '../locales/tr/dashboard.json';
import accountsTR from '../locales/tr/accounts.json';
import insightsTR from '../locales/tr/insights.json';

import commonSV from '../locales/sv/common.json';
import authSV from '../locales/sv/auth.json';
import tradingSV from '../locales/sv/trading.json';
import toolsSV from '../locales/sv/tools.json';
import pagesSV from '../locales/sv/pages.json';
import dashboardSV from '../locales/sv/dashboard.json';
import accountsSV from '../locales/sv/accounts.json';
import insightsSV from '../locales/sv/insights.json';

// Define resources
const resources = {
  en: {
    common: commonEN,
    auth: authEN,
    trading: tradingEN,
    tools: toolsEN,
    pages: pagesEN,
    dashboard: dashboardEN,
    accounts: accountsEN,
    insights: insightsEN,
  },
  tr: {
    common: commonTR,
    auth: authTR,
    trading: tradingTR,
    tools: toolsTR,
    pages: pagesTR,
    dashboard: dashboardTR,
    accounts: accountsTR,
    insights: insightsTR,
  },
  sv: {
    common: commonSV,
    auth: authSV,
    trading: tradingSV,
    tools: toolsSV,
    pages: pagesSV,
    dashboard: dashboardSV,
    accounts: accountsSV,
    insights: insightsSV,
  },
};

// Initialize i18n
i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources,
    fallbackLng: 'en', // Fallback language
    defaultNS: 'common', // Default namespace
    ns: ['common', 'auth', 'trading', 'tools', 'pages', 'dashboard', 'accounts', 'insights'], // Available namespaces
    
    detection: {
      // Order of language detection
      order: ['localStorage', 'navigator'],
      // Keys to lookup language from
      lookupLocalStorage: 'i18nextLng',
      // Cache user language
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    react: {
      useSuspense: false, // Disable suspense for easier error handling
    },
  });

export default i18n;

